import { Navigate, createFileRoute } from '@tanstack/react-router'

import { ACCOUNT_PATHS, DevelopmentPanel } from '@/features/user/profile'
import { useDebugPanelEligible } from '@/shared/lib/debug-panel/useDebugPanelEligible'

/**
 * Ferramental de staff. Não-elegível não vê a entrada na faixa de navegação e
 * também não alcança a seção por URL direta.
 */
function DevelopmentRoute() {
  const eligible = useDebugPanelEligible()

  if (!eligible) return <Navigate to={ACCOUNT_PATHS.profile} replace />

  return <DevelopmentPanel />
}

export const Route = createFileRoute('/_event/minha-conta/desenvolvimento')({
  component: DevelopmentRoute
})
